import React, {
    ChangeEvent,
    useEffect,
    useRef,
    useState,
    memo,
    useMemo,
} from "react";
import { Styles } from "react-modal";
import { useDispatch, connect } from "react-redux";
import {
    ButtonsWrapper,
    ButtonsDiv,
    IconWrapper,
    CustomFilterIcon,
    CustomRoundPlusIcon,
    CustomSquareMinusIcon,
    ModalContentWrapper,
    SelectDiv,
    TickerItemDiv,
    TickerName,
    TickersSelectWrapper,
    TickersTitle,
    TopElementsDiv,
} from "./tickersPickerModalStyles";
import { SearchInput } from "../Inputs/inputsStyles";
import { GreenButton, RedButton, WhiteButton } from "../Buttons/buttonsStyles";
import BasedModal from "../BaseModalComponents/BasedModal";
import { useAppSelector } from "../../hooks/redux";
import notifyError from "utils/Notifications/Error";
import notifySuccess from "utils/Notifications/Success";
import {
    setAvailableTickers,
    setPickedTickers as _pickedTickers,
} from "store/reducers/quotes";
import { setUploadedFile, setSelectedTickers } from "store/reducers/quotes";
import TickerPickerView from "components/ticker-picker-view";

const allowed_file_extensions = ["csv"];

function _sort(a: string, b: string) {
    return a.localeCompare(b);
}

function processText(long_text: string, file_name: string, onEnd: Function) {
    const arr = long_text.split(/[\r\n]+/);
    const header = arr[0];
    if (header !== "ID.depend") {
        notifyError("Файл не содержит необходимый заголовок");
        return;
    }
    const tickers = Array.from(new Set(arr.filter((e) => e !== header)));
    if (typeof onEnd === "function") {
        onEnd(tickers, file_name);
        notifySuccess("Тикеры добавлены");
    }
    return tickers;
}

const scrollStyles = {
    backgroundColor: "#7CBE7B",
    width: "6px",
    borderRadius: "10px",
};

interface IProps {
    isOpen: boolean;
    onRequestClose: () => void;
    style?: Styles | undefined;
    workspaceId?: number;
    tabId: number | null;
    openFilterModal: () => void;
    applyCallback: (picked_tickers: string[]) => void;
    picked_tickers: any[];
    table_id?: string;
}

interface StateType {
    available_tickers: string[];
    picked_tickers: string[];
    at_last: string[];
    pt_last: string[];
    search_available?: string[];
    search_picked?: string[];
}

const TickersPickerModal = ({
    isOpen,
    onRequestClose,
    openFilterModal,
    style,
    applyCallback,
    picked_tickers,
    table_id,
}: IProps) => {
    const { available_tickers_persistent: availableTickers } = useAppSelector(
        (state) => state.quotes
    );
    const [state, setState] = useState<StateType>({
        available_tickers: [],
        picked_tickers: [],
        at_last: undefined,
        pt_last: undefined,
    });
    const _uploaded_file = useAppSelector(
        (state) => state.quotes.uploaded_file
    );
    const uploaded_file = _uploaded_file[table_id] || {};

    useEffect(() => {
        if (!Array.isArray(availableTickers)) {
            return;
        }
        const check = true;
        const l = state.at_last;
        if (!Array.isArray(l)) {
            return setState((s) => ({
                ...s,
                at_last: availableTickers,
                available_tickers: availableTickers.filter(
                    (x) => !picked_tickers.includes(x)
                ),
            }));
        }
    }, [availableTickers]);

    useEffect(() => {
        const check = true;
        const l = state.pt_last;
        if (!Array.isArray(l)) {
            setState((s) => ({
                ...s,
                pt_last: picked_tickers,
                picked_tickers,
            }));
        }
    }, [picked_tickers]);

    const dispatch = useDispatch();
    let inputFileRef = useRef<HTMLInputElement | null>(null);

    const [searchAvailable, setSearchAvailable] = useState("");
    const [searchChosen, setSearchChosen] = useState("");

    useEffect(() => {
        const s = searchAvailable;
        const valid = typeof s === "string" && s.length > 0;

        if (valid) {
            return setState((_) => ({
                ..._,
                search_available: _.available_tickers.filter((x) =>
                    x.includes(s)
                ),
            }));
        }

        return setState((_) => ({
            ..._,
            search_available: undefined,
        }));
    }, [searchAvailable]);

    useEffect(() => {
        const s = searchChosen;
        const valid = typeof s === "string" && s.length > 0;
        if (valid) {
            return setState((_) => ({
                ..._,
                search_picked: _.picked_tickers.filter((x) => x.includes(s)),
            }));
        }

        return setState((_) => ({
            ..._,
            search_picked: undefined,
        }));
    }, [searchChosen]);

    const onFileReadEnd = (tickers: string[], name: string) => {
        const valid_tickers = tickers.filter((x) =>
            availableTickers.includes(x)
        );

        setState((s) => ({
            ...s,
            picked_tickers: tickers,
            available_tickers: availableTickers.filter(
                (x) => !tickers.includes(x)
            ),
        }));

        //applyCallback(valid_tickers);
        /*
        dispatch(setSelectedTickers({
            id: table_id,
            data: tickers
        }));
        */
        dispatch(
            _pickedTickers({
                id: table_id,
                picked_tickers: tickers,
            })
        );

        dispatch(
            setUploadedFile({
                caller: table_id,
                names: Array.isArray(tickers) ? tickers : [],
                name,
            })
        );
    };

    const changeSearchAvailable = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchAvailable(e.target.value.toUpperCase());
    };

    const changeSearchChosen = (e: ChangeEvent<HTMLInputElement>) => {
        setSearchChosen(e.target.value.toUpperCase());
    };

    const handleCancelMiddleware = () => {
        dispatch(
            setUploadedFile({
                caller: table_id,
                names: [],
                name: undefined,
            })
        );
        onRequestClose();
    };

    const handleAddAll = () => {
        setState((s) => ({
            ...s,
            picked_tickers: Array.from(
                new Set([...availableTickers, ...s.picked_tickers])
            ),
            available_tickers: [],
        }));
    };

    const handleRemoveAll = () => {
        setState((s) => ({
            ...s,
            picked_tickers: [],
            available_tickers: Array.from(
                new Set([...availableTickers, ...s.picked_tickers])
            ),
        }));
    };

    const handleTickerAddToListClick = (name: string) => {
        setState((s) => ({
            ...s,
            picked_tickers: s.picked_tickers.concat(name).sort(_sort),
            available_tickers: s.available_tickers
                .filter((x) => x !== name)
                .sort(_sort),
            search_available: Array.isArray(s.search_available)
                ? s.search_available.filter((x) => x !== name).sort(_sort)
                : s.search_available,
        }));
    };

    const handleTickerRemoveFromListClick = (name: string) => {
        setState((s) => ({
            ...s,
            available_tickers: s.available_tickers.concat(name).sort(_sort),
            picked_tickers: s.picked_tickers
                .filter((x) => x !== name)
                .sort(_sort),
            search_picked: Array.isArray(s.search_picked)
                ? s.search_picked.filter((x) => x !== name).sort(_sort)
                : s.search_picked,
        }));
    };

    const handleTickersApplyClick = () => {
        // dispatch(patchQuotes({tickers: quotes.pickedTickers, id: tabId}))
        applyCallback(state.picked_tickers);
        onRequestClose();
        //dispatch(resetPickedTickers())
    };

    const loadFileHandler = () => {
        inputFileRef?.current?.click();
    };

    const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        const input = e.target;
        if (!input || (input && !input.files)) {
            notifyError("Некорректный файл");
            return;
        }
        if (input && input.files && !input.files[0]) {
            notifyError("Непредвиденная ошибка");
            return;
        }
        //@ts-ignore
        const file_name = input.files[0].name;
        if (typeof file_name !== "string") {
            notifyError("Некорректное имя файла");
            return;
        }
        const displayed_file_name =
            typeof file_name === "string"
                ? file_name.slice(0, 8)
                : "no_file_name";
        const ext = getExtension(file_name);
        //@ts-ignore
        readContent(input.files[0], (text) =>
            processText(text, displayed_file_name, onFileReadEnd)
        );

        if (!ext || !allowed_file_extensions.includes(ext)) {
            notifyError(
                `Некорректное расширение файла. Допустимые расширения: ${allowed_file_extensions.join(
                    " "
                )}`
            );
            return;
        }

        //dispatch(setQueryFilter(''))
        //setFileName(displayed_file_name);
    };

    const readContent = async (file: File, callback: Function) => {
        const reader = new FileReader();
        reader.readAsText(file);
        reader.onload = (e) => {
            const text = e.target?.result;
            if (typeof callback === "function") {
                callback(text);
            }
        };
    };

    function getExtension(file_name: string) {
        const arr = file_name.split(".");
        return arr[arr.length - 1];
    }

    return (
        <BasedModal
            style={style}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <div>
                <ModalContentWrapper>
                    <TickersSelectWrapper>
                        <TopElementsDiv>
                            <TickersTitle>Доступные тикеры</TickersTitle>
                            <SearchInput
                                type="text"
                                value={searchAvailable}
                                onChange={changeSearchAvailable}
                                placeholder="Поиск"
                            />
                        </TopElementsDiv>

                        <TickerPickerView
                            data={
                                state.search_available
                                    ? state.search_available
                                    : state.available_tickers
                            }
                            type={"available"}
                            onIconClick={handleTickerAddToListClick}
                        />
                    </TickersSelectWrapper>
                    <TickersSelectWrapper>
                        <TopElementsDiv>
                            <TickersTitle>Выбранные</TickersTitle>
                            <SearchInput
                                type="text"
                                value={searchChosen}
                                onChange={changeSearchChosen}
                                placeholder="Поиск"
                            />
                        </TopElementsDiv>
                        <SelectDiv
                            thumbSize={60}
                            renderThumbVertical={(props) => (
                                <div
                                    {...props}
                                    style={{
                                        ...props.style,
                                        ...scrollStyles,
                                    }}
                                />
                            )}
                        >
                            {state.picked_tickers &&
                            state.picked_tickers.length ? (
                                <TickerPickerView
                                    data={
                                        state.search_picked
                                            ? state.search_picked
                                            : state.picked_tickers
                                    }
                                    type={"picked"}
                                    onIconClick={
                                        handleTickerRemoveFromListClick
                                    }
                                />
                            ) : (
                                <></>
                            )}
                        </SelectDiv>
                    </TickersSelectWrapper>
                </ModalContentWrapper>
                <ButtonsWrapper>
                    <ButtonsDiv>
                        <WhiteButton onClick={openFilterModal}>
                            <CustomFilterIcon />
                        </WhiteButton>
                        <WhiteButton
                            style={{ width: "30%" }}
                            onClick={loadFileHandler}
                        >
                            {
                                //@ts-ignore
                                typeof uploaded_file.name === "string" &&
                                //@ts-ignore
                                uploaded_file.name.length &&
                                //@ts-ignore
                                uploaded_file.caller === table_id
                                    ? //@ts-ignore
                                      `Вы загрузили файл ${uploaded_file.name}`
                                    : "Из файла"
                            }
                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={(input) => (inputFileRef.current = input)}
                                onChange={handleFileChange}
                            />
                        </WhiteButton>
                        <WhiteButton
                            onClick={handleAddAll}
                            style={{ width: "30%" }}
                        >
                            Добавить всё
                        </WhiteButton>
                        <WhiteButton
                            onClick={handleRemoveAll}
                            style={{ width: "30%" }}
                        >
                            Очистить всё
                        </WhiteButton>
                    </ButtonsDiv>
                    <ButtonsDiv>
                        <RedButton onClick={handleCancelMiddleware}>
                            Отменить
                        </RedButton>
                        <GreenButton onClick={handleTickersApplyClick}>
                            Применить
                        </GreenButton>
                    </ButtonsDiv>
                </ButtonsWrapper>
            </div>
        </BasedModal>
    );
};

export default memo(TickersPickerModal);
